import { create } from 'zustand'
import {
  pushNotice,
  dismissNotice,
  clearOrdinary as clearOrdinaryList,
  type MeetingNotice,
} from '../services/notice-stack'

/**
 * What the in-meeting notice stack shows: the toast-like notices (recording
 * started, someone raised a hand, and so on), capped at three with the oldest
 * dropped first. The cap-and-replace rules themselves are pure functions in
 * `notice-stack.ts`; this store is just where they are applied and where the
 * result is read from.
 */

type MeetingNoticesState = {
  ordinary: MeetingNotice[]
  pushOrdinary: (notice: MeetingNotice) => void
  dismissOrdinary: (id: string | number) => void
  clearOrdinary: () => void
  /** Everything gone: the next meeting must not inherit this one's notices. */
  reset: () => void
}

export const useMeetingNoticesStore = create<MeetingNoticesState>((set) => ({
  ordinary: [],
  pushOrdinary: (notice) => set((s) => ({ ordinary: pushNotice(s.ordinary, notice) })),
  dismissOrdinary: (id) => set((s) => ({ ordinary: dismissNotice(s.ordinary, id) })),
  clearOrdinary: () => set({ ordinary: clearOrdinaryList() }),
  reset: () => set({ ordinary: clearOrdinaryList() }),
}))
